module.exports = __webpack_public_path__ + "img/home-pic-14.b3c0b0ec.jpg";